var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BA01244E-74B0-46D6-90D9-D05AE9FC2CE5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Sub-Category--Approved/Flagged",
    transform: "translate(-1233.000000, -185.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "comment",
    transform: "translate(1233.913630, 186.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96042832,4.9898467 C9.96042832,4.49980035 9.88855323,4.01240363 9.74696854,3.54325632 C9.19856123,1.722705 7.66124268,0.373388681 5.78493849,0.0657520849 C3.9086343,-0.241884511 2.02092445,0.545868235 0.919867995,2.09597545 C-0.181188458,3.64608266 -0.303360402,5.68791441 0.605002276,7.35825417 L0.018312673,9.41751303 C-0.018904468,9.54814378 0.00733574868,9.68866844 0.0891866442,9.79706557 C0.17103754,9.9054627 0.299011684,9.96913157 0.434840642,9.96913157 C0.474948798,9.96913157 0.514859198,9.96350829 0.553477507,9.95267787 L2.61316935,9.36555528 C2.90540196,9.52569827 3.21364277,9.65471243 3.53282154,9.75047562 C4.00188896,9.89562185 4.49013301,9.96933283 4.98114384,9.96913157 C7.72984081,9.96602919 9.95732633,7.73854367 9.96042832,4.9898467 Z",
    id: "Path",
    stroke: "#113982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9748438,12.4483818 L12.3881542,10.389123 C13.6311734,8.10136238 12.8983633,5.24208082 10.7081869,3.83421972 C11.0594803,5.55265319 10.6188036,7.33794192 9.50823149,8.69553176 C8.39765936,10.0531216 6.7351126,10.8388633 4.98114384,10.8350937 C4.59522639,10.8339044 4.21040103,10.7940148 3.83244457,10.7160238 C4.75207792,12.1326534 6.32308206,12.9911478 8.01201264,13 C8.83949029,13.0001149 9.65378904,12.7927441 10.3804201,12.3968571 L12.439679,12.9835467 C12.4782973,12.9943771 12.5182077,13 12.5583158,13 C12.6941448,13 12.8221189,12.9363315 12.9039698,12.8279344 C12.9858207,12.7195372 13.0120609,12.5790126 12.9748438,12.4483818 L12.9748438,12.4483818 Z",
    id: "Path",
    fillOpacity: 0.4,
    fill: "#113982"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.b926ccf6e2f991ab148afa930cef622e.svg";
export { ForwardRef as ReactComponent };